<template>
  <div class="bg-white shadow-md rounded-xl p-6 w-full flex flex-col justify-between" style="height: 100%;">
    <!-- Title & Dropdown -->
    <div class="flex justify-between items-center">
      <p class="text-gray-900 font-semibold text-lg">Employee Completion</p>
      <select 
        v-model="selectedPartOption" 
        @change="handleSelectPartOption"
        class="border border-gray-300 text-sm px-3 py-1 rounded-md focus:outline-none focus:ring focus:border-gray-400 bg-gray-100"
      >
        <option value="general">General</option>
        <option value="part1">Part 1</option>
        <option value="part2">Part 2</option>
        <option value="part3">Part 3</option>
        <option value="part4">Part 4</option>
      </select>
    </div>

    <!-- Donut Chart -->
    <div class="flex justify-center py-4">
      <highcharts :options="doughnutChartOptions" class="w-[180px] h-[180px]"></highcharts>
    </div>

    <!-- Completion Percentage Info -->
    <div class="flex items-center justify-center text-sm text-gray-600">
      <div class="w-3 h-3 bg-[#1307A8] rounded-full mr-2"></div>
      Employee completion - {{ admin_part_percentage }}%
    </div>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import Api from "../../../router/api";
import Vue from "vue";

export default {
  components: {
    HighchartsVue
  },
  data() {
    return {
      selectedPartOption: "general",
      admin_part_percentage: 0,
      doughnutChartOptions: {
        chart: {
          type: "pie",
          width: 180,
          height: 180,
          backgroundColor: "transparent"
        },
        title: {
          text: ""
        },
        series: [
          {
            name: "Completion",
            colorByPoint: true,
            data: [],
            size: "90%",
            innerSize: "70%",
            showInLegend: false,
            dataLabels: {
              enabled: false
            }
          }
        ],
        colors: ["#1307A8"],
        credits: {
            enabled: false
        }
      }
    };
  },
  methods: {
    handleSelectPartOption() {
      Api.getAdminPartPercentage(this.selectedPartOption)
        .then((response) => {
          const completion = response.data.admin_part_percentage;
          const remaining = 100 - completion;

          Vue.set(this.doughnutChartOptions.series[0], "data", [
            { name: "Completed", y: completion, color: "#1307A8" },
            { name: "Remaining", y: remaining, color: "#E5E7EB" }
          ]);

          this.admin_part_percentage = completion.toFixed(2);
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: error.response.data.message || "Something went wrong",
            showConfirmButton: true
          });
        });
    }
  },
  mounted() {
    this.handleSelectPartOption();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/dashboard1/UniqueEmployee.vue